import FAQ from "views/FAQ"

const FAQPage = () => {
    return <FAQ/>
}

FAQPage.chains = []

export default FAQPage
